import React from 'react';
import Icon from 'components/lib/icons/icon';

export default props => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M11 6A5 5 0 111 6a5 5 0 0110 0zm-1.126 4.582a6 6 0 11.707-.707l4.773 4.771a.5.5 0 01-.708.708l-4.772-4.772z"
      fillRule="evenodd"
    />
  </Icon>
);
